import { Box, Paper, Typography, useTheme } from '@mui/material';
import React, { FC, useEffect, useMemo } from 'react';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { GoPlus } from "react-icons/go";
import { Table } from '../../../Components/Table/table.component';
import { useNavigate } from 'react-router-dom';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { useListProducts } from './products-list.hook';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Flex } from '../../../Components/Flex/flex.component';
import { Switch } from '../../../Components/Form/Switch/switch.component';
import { Loader } from '../../../Components/Loader';
import { Can } from '../../../Components/Can';
import { IoFileTrayOutline, IoFilterOutline } from 'react-icons/io5';
import { FinancialFiltersDrawer } from '../../../Components/Drawer/variants/financial-filters/financial-filters-drawer.component';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import { FaBox, FaEdit, FaTrash } from 'react-icons/fa';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { DestroyProductUseCase } from '../../../Usecase/Products/destroy-product-usecase';
import { ProductsFilterDrawer } from '../../../Components/Drawer/variants/products-filter/products-filter-drawer.component';
import { ExportExcelProductUseCase } from '../../../Usecase/Products/export-excel-product-usecase';

interface IProductsList {
    listProductUseCase: ListProductUseCase
    destroyProductUseCase: DestroyProductUseCase
    exportExcelProductUseCase: ExportExcelProductUseCase
}
const ProductsList : FC<IProductsList> = ({ listProductUseCase, destroyProductUseCase, exportExcelProductUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const { listProdcuts, list, totalRegisters, control, loading, setShowFiltersModal, showFiltersModal, setItemToDestroy, itemToDestroy, handleFilterSelect, handleDestroyProduct, currentFilters, handleExportExcel, handlePageChangeProducts } = useListProducts({
        listProductUseCase,
        destroyProductUseCase,
        exportExcelProductUseCase
    })


    useEffect(() => {
        listProdcuts({ page: 1})
    }, [])


    const columns = useMemo(() => {
        const createColumns: any[] = [
          {
            field: 'photo',
            headerName: 'Imagem',
            wdith: 150,
            renderCell: (params: any) => <Box component='img' src={params.value} sx={{ width: '80px', height: '80px', objectFit: 'contain'}} />
          },
          {
            field: 'internalName',
            headerName: 'Nome Importado',
            flex: 1,
            renderCell: (params: any) => <Flex height='100%' alignItems='center'><Typography sx={{flexWrap: 'wrap', whiteSpace: 'normal', wordBreak: 'break-word'}} >{params.value}</Typography></Flex>
          },
          {
            field: 'name',
            headerName: 'Nome Amigável',
            flex: 1,
            renderCell: (params: any) => <Flex height='100%' alignItems='center'><Typography sx={{flexWrap: 'wrap', whiteSpace: 'normal', wordBreak: 'break-word'}} >{params.value}</Typography></Flex>
          },
          {
            field: 'code',
            headerName: 'Código',
            width: 120
          },
          {
            field: 'b2bNuvemShopPrice',
            headerName: 'Preço - B2B',
            width: 200
          },
          {
            field: 'b2cNuvemShopPrice',
            headerName: 'Preço - B2C',
            width: 200
          },
          // {
          //   field: "actions",
          //   headerName: "Ações",
          //   headerAlign: "right",
          //   flex: 1,,
            
          //   renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={() => {}} editLink={`/products-form/${params.row.id}`} />
          // }
          {
            field: "actions",
            headerName: "Ações",
            renderCell: (params: any) => <ButtonActionMenu options={[
              {
                title: 'Editar',
                onClick: () => navigate(`/products-form/${params.row.id}`),
                
                icon: <FaEdit size={18} />
              },
              {
                title: 'Ver Estoque',
                onClick: () => navigate(`/stocks-details/${params.row.id}`),
                
                icon: <FaBox size={18} />
              },
              
              {
                title: 'Excluir',
                onClick: () => setItemToDestroy(params.row),
                titleColor: 'error.main',
                icon: <FaTrash size={18} />
              }
            ]} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
      <Can permissions={['menu:products:manage']}>
        <ConfirmDialog title='Remover Produto' onCancel={() => setItemToDestroy(undefined)} description='Você tem certeza?' open={!!itemToDestroy} onConfirm={handleDestroyProduct}  /> 
         {/* <FinancialFiltersDrawer handleSelect={e => {}} open={showFiltersModal} title='Filtros' onToggle={() => setShowFiltersModal(prev => !prev)}  />   */}
        <BaseScreen>
            <Paper >
                {loading && <Loader />}

                <ProductsFilterDrawer
                  handleSelect={handleFilterSelect} 
                  open={showFiltersModal} 
                  title='Filtros' 
                  onToggle={() => setShowFiltersModal(prev => !prev)} 
                />
                <BaseContentPage 
                    title='Produtos'
                    search
                    searchFunction={(data) => listProdcuts({ ...currentFilters, searchBy: data.searchBy, page: data.page })}
                    breadcrumb={[{ title: 'Produtos', link: "/products-list"}, { title: 'Listagem'}]}
                    Action={() => <Flex gap={2} alignItems='center'justifyContent='flex-end'>
                     <Button LeftIcon={() => <IoFilterOutline size={18} />} sx={{ width: '100px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => setShowFiltersModal(true)}>Filtros</Button>
                     <Button LeftIcon={() => <IoFileTrayOutline size={18} />} sx={{ width: '100px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={handleExportExcel}>Excel</Button>
                      <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/products-form')}
                    >Adicionar</Button>
                    </Flex>}
                >
                  {!!list?.length ? <Table data={list} columns={columns} onPageChange={handlePageChangeProducts} totalCount={totalRegisters} /> : <Placeholder description='Nenhum dado encontrado.' />}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { ProductsList }